import { render, staticRenderFns } from "./ChecboxIcon.vue?vue&type=template&id=8827df1c&"
import script from "./ChecboxIcon.vue?vue&type=script&lang=js&"
export * from "./ChecboxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports